import { Provider } from "@angular/core";
import { ApiConfiguration, ApiConfigurationParams } from "./jobimag/api-configuration";

export function provideApi(params: ApiConfigurationParams): Provider[] {
    return [
        {
            provide: ApiConfiguration,
            useValue: params
        }
    ];
}
